import { render, staticRenderFns } from "./SynonymsTable.vue?vue&type=template&id=5f6916f2&scoped=true"
import script from "./SynonymsTable.vue?vue&type=script&lang=js"
export * from "./SynonymsTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f6916f2",
  null
  
)

export default component.exports